import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useNavigate } from "react-router-dom";
import documentTypes from "../../../app/js/documents/documentTypes";

const DealComplianceModal = (props) => {
    const { dealKey, documentTypeKey, documentWarning, handleDocumentWarning, handleConfirmWarning } = props;
    const navigate = useNavigate();
    const confirmWarning = async () => {
        await handleConfirmWarning(documentWarning.callback);
        if (dealKey && navigate) {
            setTimeout(() => {
                navigate(`/deal/${dealKey}`);
            }, 1500);
        }
    };
    return (
        <Dialog
            open={documentWarning.open}
            onClose={() => handleDocumentWarning(false, documentWarning.proceed, [])}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Are you sure you want to submit?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    You are responsible for ensuring this deal has the necessary legal documents. The following
                    documents are still required for this deal to be compliant:
                    <ul>
                        {documentWarning.docs.map((doc) => (
                            <li key={`deal-compliance-dialog-doc-${doc}`}>
                                {documentTypes[documentTypeKey][doc]["display"] ?? ""}
                            </li>
                        ))}
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleDocumentWarning(false, false, [])} color="primary">
                    Add more docs
                </Button>
                <Button onClick={confirmWarning} color="primary" autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DealComplianceModal;
